import { createCoralogixAdapter } from './adapters/coralogix';
import type {
  TelemetryAdapter,
  TelemetryConfig,
  TelemetryManager,
  TelemetryUserContext,
} from './types';

export function createTelemetryManager(
  applicationName: string,
): TelemetryManager {
  const adapters: TelemetryAdapter[] = [
    createCoralogixAdapter(applicationName),
  ];

  let initialized = false;

  return {
    initTelemetry(config: TelemetryConfig) {
      if (initialized) {
        return true;
      }

      let didInitialize = false;
      for (const adapter of adapters) {
        try {
          if (adapter.init(config)) {
            didInitialize = true;
          }
        } catch (err) {
          console.error(`[telemetry] failed to init ${adapter.name}`, err);
        }
      }

      if (didInitialize) {
        initialized = true;
      }

      return didInitialize;
    },

    setTelemetryUser(user: TelemetryUserContext) {
      for (const adapter of adapters) {
        try {
          adapter.setUser?.(user);
        } catch (err) {
          console.error(
            `[telemetry] failed to set user on ${adapter.name}`,
            err,
          );
        }
      }
    },

    teardownTelemetry() {
      for (const adapter of adapters) {
        try {
          adapter.teardown?.();
        } catch (err) {
          console.error(`[telemetry] failed to teardown ${adapter.name}`, err);
        }
      }
      initialized = false;
    },
  };
}
